module.exports = __webpack_public_path__ + "img/flower.8f03eb04.svg";